import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setManageUserModals, tryUpdateUserFeatures} from "../../../redux/slices/manageUserSlice";
import useDidMount from "../../../hooks/useDidMount";
import FeaturesSelect from "./FeaturesSelect";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import {CustomIconRef} from "../../../components/CustomIcon";
import {FEATURE_CAMPAIGN, FEATURE_PRESCRIPTION, FEATURE_SHIFT} from "../constants";


export default function AddFeaturesModal() {

  const {modal, data: user} = useSelector((state => state.manageUser.modals.feature));
  const dispatch = useDispatch();
  const [newFeatures, setNewFeatures] = useState([]);

  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);

  const submitForm = () => {
    dispatch(tryUpdateUserFeatures({
      features: newFeatures

    }));
  };

  useDidMount(() => {
    if (modal) {
      setNewFeatures(user?.features ?? []);
    } else {
      setNewFeatures([]);
    }
  }, [modal]);

  const onFeatureSelect = (feature) => {
    setNewFeatures([...newFeatures, feature]);
  };

  const onFeatureRemove = (feature) => {
    setNewFeatures(newFeatures.filter((f) => f.id !== feature.id));
  };
  return (
    <CustomModal title="Permissions"
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageUserModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing}
                                       onClick={submitForm}>Confirm</CustomButton>}>
      <div className="text-lg font-semibold mb-6">Manage the permissions of the user by adding/removing features.</div>
      <div className="flex flex-col">        
        <div className="flex items-end">
          <FeaturesSelect exclude={newFeatures} onFeatureSelect={onFeatureSelect}/>

          <FeatureActions className="ml-2 mb-3" setNewFeatures={setNewFeatures}/>

        </div>
        <ChipGroup>          
          {
            newFeatures.map((f) => <ChipSecondary label={f.name} key={f.id} onClose={() => onFeatureRemove(f)}/>)
          }

        </ChipGroup>

        
      </div>
    </CustomModal>
  );
}

const FeatureActions = ({className = "", setNewFeatures}) => {

  const {init, data} = useSelector((state => state.manageUser.features));

  const setPharmacistAdminFeatures = (isPharmacist) => {
    const pharmacistFeatures = [FEATURE_CAMPAIGN, FEATURE_SHIFT, FEATURE_PRESCRIPTION];

    setNewFeatures(data.filter((f) => isPharmacist ? pharmacistFeatures.some((pf) => pf.toLowerCase() === f.frontend_key.toLowerCase())

    :!pharmacistFeatures.some((pf) => pf.toLowerCase() === f.frontend_key.toLowerCase())

    ));
  };


  return (
    <div className={className}>
      <DropdownMenu
        trigger={({triggerRef, isSelected, testId, ...props}) => (
          <CustomIconRef ref={triggerRef} size="2xl" className="p-3 text-black cursor-pointer" {...props}
                         icon="more_vert"/>
        )}
      >
        <DropdownItemGroup>
          <DropdownItem onClick={() => setNewFeatures([])}>Revoke All</DropdownItem>
          <DropdownItem onClick={()=>setPharmacistAdminFeatures(true)}>Pharmacist Permissions</DropdownItem>
          <DropdownItem onClick={() => setPharmacistAdminFeatures(false)}>Except Pharmacist Permissions</DropdownItem>
        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};

